(() => {
  const SELECTOR_READY = 'zipitQuantityReady';

  const syncBundlerChoice = (selectedIndex) => {
    const choices = [...document.querySelectorAll(
      '.bundler-volume-target-element.bndlr-automatic-volume-bundle .bndlr-radio-container'
    )];
    const choice = choices[selectedIndex];
    if (!choice || choice.dataset.zipitSynced === 'true') return;

    choices.forEach((item) => delete item.dataset.zipitSynced);
    choice.dataset.zipitSynced = 'true';
    choice.click();
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (_error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const updateButtonPrices = (root, selected) => {
    const label = root.querySelector(`label[for="${CSS.escape(selected.id)}"]`);
    if (!label) return;

    const quantity = Number.parseInt(selected.value, 10) || 1;
    const basePrice = Number.parseInt(root.dataset.basePrice, 10) || 0;
    const percentageLeft = Number.parseFloat(label.dataset.percentageLeft || '1');
    const fixedDiscount = Number.parseFloat(label.dataset.fixedDiscount || '0');
    const totalCents = Math.max(0, Math.round(basePrice * quantity * percentageLeft - fixedDiscount));
    const displayPrice = `${formatMoney(totalCents)} •`;
    const section = root.dataset.section;

    [
      document.getElementById(`main-atc-price-${section}`),
      document.getElementById(`sticky-atc-price-${section}`),
      ...document.querySelectorAll(`.main-atc-price-span-${CSS.escape(section)}`),
    ].filter(Boolean).forEach((element) => {
      element.textContent = displayPrice;
    });
  };

  const initialiseSelector = (root) => {
    if (root.dataset[SELECTOR_READY] === 'true') return;

    const radios = [...root.querySelectorAll('input[type="radio"][name="quantity"]')];
    if (!radios.length) return;

    const formId = radios[0].getAttribute('form');
    const form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    root.dataset[SELECTOR_READY] = 'true';

    const groupName = `zipit_quantity_choice_${root.dataset.section || 'product'}`;
    radios.forEach((radio) => {
      radio.name = groupName;
    });

    let quantityInput = form.querySelector('[data-zipit-selected-quantity]');
    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.dataset.zipitSelectedQuantity = 'true';
      form.appendChild(quantityInput);
    }

    const sync = () => {
      const selected = radios.find((radio) => radio.checked) || radios[0];
      quantityInput.value = selected.value;
      updateButtonPrices(root, selected);
      syncBundlerChoice(radios.indexOf(selected));
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    form.addEventListener('submit', sync, { capture: true });
    sync();
  };

  const initialiseAll = () => {
    document.querySelectorAll('quantity-breaks').forEach(initialiseSelector);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);

  const bundlerObserver = new MutationObserver(() => {
    document.querySelectorAll('quantity-breaks').forEach((root) => {
      const radios = [...root.querySelectorAll('input[type="radio"][name^="zipit_quantity_choice_"]')];
      if (!radios.length) return;
      const selected = radios.find((radio) => radio.checked) || radios[0];
      syncBundlerChoice(radios.indexOf(selected));
    });
  });
  bundlerObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
